import { useToast } from "vue-toastification";
import store from "/@/store";

export default function useFuneralBenefit() {
  const toast = useToast();

  const getFuneralHomes = async () => {
    try {
      const res = await store.dispatch("funeral/getFuneralHomes");

      return res;
    } catch (err: any) {
      toast.error(err.response.data.message);

      return Promise.reject(err);
    }
  };

  const createFuneralApplication = async (data: any) => {
    try {
      const res = await store.dispatch(
        "funeral/createFuneralApplication",
        data
      );

      return res;
    } catch (err: any) {
      toast.error(err.response.data.description);

      return Promise.reject(err);
    }
  };

  return {
    getFuneralHomes,
    createFuneralApplication,
  };
}
